import axios from 'axios'
import Instance from '../main'

export default {
  install: function install (Vue, host) {
    Object.defineProperties(Vue.prototype, {
      $rpc: {
        get () {
          return new RPC(Vue, host)
        }
      }
    })
  }
}

class RPC {
  constructor (Vue, host) {
    this.vue = new Vue()
    this.id = 0
    this.host = host
  }

  call (method, params, additional = {}) {
    const data = {
      'jsonrpc': '2.0',
      'method': method,
      'params': params,
      'id': this.id
    }

    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/json-rpc' },
      data: data,
      url: this.host,
      ...additional
    }

    this.id++

    return new Promise((resolve, reject) => {
      this.vue.$http(options).then((res) => {
        if (res.data.error) {
          if (res.data.error.code === 3030) {
            Instance.$auth.refresh().then(() => {
              this.vue.$http(options).then(res => {
                resolve(res)
              }).catch(e => {
                reject(e)
              })
            }).catch(error => {
              reject(error)
            })
          } else {
            reject(res)
          }
        } else {
          resolve(res)
        }
      }).catch((err) => {
        if (err.data.error) {
          if (err.data.error.code === 3030) {
            Instance.$auth.refresh().then(() => {
              this.vue.$http(options).then(res => {
                resolve(res)
              }).catch(e => {
                reject(e)
              })
            }).catch(error => {
              reject(error)
            })
          } else {
            reject(err)
          }
        } else {
          reject(err)
        }
      })
    })
  }
}

class AxiosRPC {
  constructor () {
    this.id = 0
  }

  call (host, method, params) {
    const data = {
      'jsonrpc': '2.0',
      'method': method,
      'params': params,
      'id': this.id
    }

    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/json-rpc' },
      data: data,
      url: host
    }

    this.id++

    return new Promise((resolve, reject) => {
      axios(options).then((res) => {
        this.handleError(res)
        resolve(res)
      }).catch((err) => {
        reject(err)
        throw new Error(err)
      })
    })
  }

  handleError (response) {
    if (response.data.error) {
      throw Error(response.data.error.message)
    }
    return true
  }
}

export const axiosRPC = new AxiosRPC()



// WEBPACK FOOTER //
// ./src/plugins/RPC.js